// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__7yNrF","optout-button":"styles_optout-button__DHPY_","optin-button":"styles_optin-button__ixDSg"};